require('./bootstrap');
require('bootstrap-datepicker');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.fr');
require('ion-rangeslider');
require('@fancyapps/fancybox');
require('sticky-sidebar');
import { tns } from "tiny-slider/src/tiny-slider";


$(".datepicker").datepicker({
    defaultViewDate: new Date('01/01/1930'),
    autoclose: true,
    language: "fr"
});

$('.datepicker').on('change', function() {
    let d1 = $(this).datepicker('getDate')
    let d2 = new Date('01/12/1999')
    let d3 = new Date('01/01/1920')
    if (d1 != 'Invalid')
        if ((d1 < d2) == false || (d1 > d3) == false) {
            $(this).datepicker('update', '')
        }
})


// Press Slider
if ($('.press-slider').length) {
    var slider = tns({
        container: '.press-slider',
        items: 1,
        autoplay: false,
        controls: false,
        navPosition: 'bottom',
        responsive: {
            640: {
                edgePadding: 20,
                gutter: 20,
                items: 2
            },
            900: {
                items: 3
            },
            1199: {
                items: 4
            }
        }
    });
}

// Home Search
function hideMap() {
    $('.section2').fadeOut(150, function() {
        $('.section1').fadeIn(150);
        $('.mini-search .title').html($('.mini-search .title').data('show'));
    });
}

function showMap() {
    $('.section1').fadeOut(150, function() {
        $('.section2').fadeIn(150);
        $('.mini-search .title').html($('.mini-search .title').data('hide'));
    });
}
$('.btn-map').on('click', function(event) {
    event.preventDefault();
    showMap();
});
$('.btn-validate, .btn-close').on('click', function(event) {
    event.preventDefault();
    hideMap();
});
$('.btn-validate').on('click', function(event) {
    event.preventDefault();
    let zone = $('.map').find('[data-zone].active');
    if (zone.length > 0) {
        $('input[name="sv-zone"]').val(zone.data('zone'));
        $('input[name="sv-zipcode"]').val(zone.data('zipcodes'));

    }
    $(this).parents('form').attr('action', '/acheter?agence=' + zone.data('zone'));
});

$('.purchase-map .sv-zone').on('click', function(event) {
    let zone = $(this).data('zone');
    if (zone.length > 0) {
        $('input[name="sv-zone"]').val(zone);
        $('input[name="sv-zipcode"]').val($(this).data('zipcodes'));
    }
    // $(this).parents('form').attr('action', '/acheter?agence=' + zone.data('zone'));
});
if ($('.purchase-map input[name="sv-zone"]').length) {
    let zone = $('input[name="sv-zone"]').val();
    $('*[data-zone]').removeClass('active');
    $('[data-zone="' + zone + '"]').addClass('active');
}
$('#inputTransation').on('change', function(event) {
    event.preventDefault();
    if ($(this).val() == 'viager') {
        $('.viager-slider').fadeIn();
    } else {
        $('.viager-slider').fadeOut();
    }
});
$("#search-slider").ionRangeSlider({
    type: "double",
    grid: false,
    min: 0,
    max: 4000000,
    from: false,
    to: false,
    skin: "round",
    postfix: " €"
});

$("#search-slider-bouquet").ionRangeSlider({
    type: "double",
    grid: false,
    min: 0,
    max: 2000000,
    from: 0,
    to: 2000000,
    skin: "round",
    postfix: " €",
    grid_snap: false
});
$("#search-slider-rente").ionRangeSlider({
    type: "double",
    grid: false,
    min: 0,
    max: 10000,
    from: 0,
    to: 10000,
    skin: "round",
    postfix: " €"
});

$('#svg-map').on('click', 'path', function(event) {
    event.preventDefault();
    $(this).toggleClass('selected');
});


$('#displayfilter').click(function(e) {
    e.preventDefault();
    $('.filter-items').toggle(500);
    $(this).find('.more').toggle();
    $(this).find('.less').toggle();
    $('.filter-items').find('input[type="checkbox"]').prop('checked', false);
})

// map post
if ($("#map").length) {
    let lat = $('input[name="lat"]').val() || 48.855560;
    let lng = $('input[name="lng"]').val() || 2.2348509;
    let parisLatlng = [lat, lng];
    let map = L.map('map', { scrollWheelZoom: false }).setView(parisLatlng, 13);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);
    map.scrollWheelZoom.disable();
    map.removeControl(map.zoomControl);
    let markerpostion = [lat, lng]
    let iconurl = '/storage/soluvia/marker.png';
    let marker_icon = new L.icon({
        iconUrl: iconurl,
        iconAnchor: [32, 32]
    });
    // let marker = new L.marker(markerpostion, { icon: marker_icon }).addTo(map);
}

$('[data-fancybox="images"]').fancybox({
    loop: true,
    buttons: [
        'arrowLeft',
        'thumb',
        'arrowRight',
        'close'
    ],
    thumbs: {
        autoStart: true,
        axis: 'x'
    }
});

$('[data-fancybox="cl-group"]').fancybox({
    baseClass: "fancybox-custom-layout",
    infobar: true,
    touch: {
        vertical: false
    },
    buttons: ["close", "thumbs", "share"],
    animationEffect: "fade",
    transitionEffect: "fade",
    preventCaptionOverlap: false,
    idleTime: false,
    gutter: 0,
    thumbs: {
        autoStart: true,
        axis: 'y'
    }

});

if ($("nav.post-side").length) {
    let sidebar = new StickySidebar('nav.post-side', {
        topSpacing: 20,
        bottomSpacing: 20,
        containerSelector: '.full-content',
        innerWrapperSelector: 'nav'
    });

}

/** 
 *  Join display
 */
$('#isalone').change(function() {
    let join = $(this).prop('checked');
    $('.joininfo').toggle(500);
    $('#firstnamejoint').prop('required', !join);
    $('#lastnamejoint').prop('required', !join);
    $('#birthdayjoint').prop('required', !join);
    $('#genderjoint').prop('required', !join);
})

$('#noland').change(function() {
    let join = $(this).prop('checked');
    let opacity = !join ? 1 : 0;
    $('.superficiecontent').css('opacity', opacity);
    $('#superficie').prop('required', !join);
})

$('input[name="exposition[]"]').change(function() {
    let count = 0;
    if ($(this).prop('checked') == true) {
        $.each($('input[name="exposition[]"]'), function(k, v) {
            $(v).attr('required', false);
        })
    } else {

        $.each($('input[name="exposition[]"]'), function(k, v) {

            if ($(v).prop('checked') == false) {
                count++;

            }
            if ((k + 1 == $('input[name="exposition[]"]').length) && count == $('input[name="exposition[]"]').length) {
                $.each($('input[name="exposition[]"]'), function(k, v) {
                    $(v).attr('required', true);
                })
            }
        })
    }
})
$('*[data-zone]').click(function() {
    $('*[data-zone]').removeClass('active');
    $(this).addClass('active');
    console.log($(this).attr('data-zipcodes'));
});

$(document).ready(function() {


    if (document.cookie.indexOf("soluviacookies") === -1) {
        $("#vt-cookies").show();
    }

    $("#removecookie").click(function(e) {
        e.preventDefault();
        SetCookie('soluviacookies', 'eucookie', 365 * 10)
        $("#vt-cookies").fadeOut(500, function() { $(this).remove(); });
    });


    if ($('.newsletter-form').length > 0) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        $(".newsletter-form .btn-subscriber").click(function(e) {
            e.preventDefault();
            var thisel = $(this);
            $(this).parents('.newsletter-form').find('.msg-subscriber').html('').css('display', 'none').removeClass('has-error');
            var email = $(this).parents('.newsletter-form').find("input[name=newsletter-email]").val();
            if (!email) {
                $(this).parents('.newsletter-form').find('.msg-subscriber').html('Le champ email est obligatoire').css('display', 'block').addClass('has-error');

            } else {

                var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                if (!regex.test(email)) {
                    $(this).parents('.newsletter-form').find('.msg-subscriber').html('Adresse mail non valide').css('display', 'block').addClass('has-error');
                } else {
                    $.ajax({
                        type: 'POST',
                        url: '/subscriberRequest',
                        data: { site: 'soluvia', email: email },
                        success: function(data) {
                            console.log(data);
                            thisel.parents('.newsletter-form').find('.msg-subscriber').html(data.success).css('display', 'block');
                        }
                    });
                }


            }

        });
    }
    $("#isprinted").click(function(e) {
        e.preventDefault();
        window.print();

    })

    if ($('#estimateFrom').length > 0) {

        $('#estimateFrom').on('submit', function() {
            $('#estimateFrom [type="submit"]').attr('disabled', 'disabled')
            return true;
        })
    }
})

function SetCookie(c_name, value, expiredays) {
    var exdate = new Date()
    exdate.setDate(exdate.getDate() + expiredays)
    document.cookie = c_name + "=" + escape(value) + ";path=/" + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString())
}